'use client'

import { useEffect } from 'react'

import type { CommonProps } from '../../types/CommonProps'

type UrlParserProps = Pick<CommonProps, 'product'> & {
	searchParams: Record<string, string>
}

export function UpdatePdpUrl({ product, searchParams }: UrlParserProps): null {
	useEffect(() => {
		if (product.url) {
			const url = new URL(window.location.href)
			const pdpUrl = new URL(product.url, url.origin)
			pdpUrl.search = new URLSearchParams(searchParams).toString()

			if (pdpUrl.href !== url.href) {
				window.history.replaceState(null, '', pdpUrl.href)
			}
		}
	}, [product, searchParams])

	return null
}
